import Box from '@mui/material/Box';

export default function SmallLogo({ src }: { src: string }) {
  return <Box component="img" src={src} sx={{ cursor: 'pointer' }} />;
}
